// extracted by mini-css-extract-plugin
module.exports = {"error_message":"InfoMessage-module--error_message--20_1_","alarm":"InfoMessage-module--alarm--68U88","default":"InfoMessage-module--default--3qJv5"};